<template>
  <b-form id="rates" @submit="onSubmit($event)">
    <div class="row">
      <div class="col-sm-12">

        <b-form-group v-for="(rate, index) in form.rates" :key="index" :label="rate.code"
                      :label-for="rate.code">
          <b-form-input :id="rate.code"
                        type="number"
                        step="0.0000000000000001"
                        v-model="form.rates[index].rate">
          </b-form-input>
        </b-form-group>

        <b-button type="submit" class="float-right" variant="primary">
          Сохранить и выйти
        </b-button>

      </div>
    </div>

    <div class="form-errors"></div>
  </b-form>
</template>

<script>
import RatesDataService from "../../../services/ratesDataService";

export default {
  name: "EditRatesModal",
  props: {
    rates: Object
  },

  data() {
    return {
      form: {
        period: this.rates.period,
        rates: [],
      },
    }
  },

  methods: {
    onSubmit(e) {
      e.preventDefault()
      RatesDataService.saveRates(this.form)
        .then(response => {
          if (response.status === true) {
            window.location.href = '/exchange-rates';
          }
        })
    },

    handleInputRates() {
      this.rates.currencies.forEach((rateModel, index) => {
        this.form.rates[index] = {}
        if (rateModel.type !== 'auto') {
          this.form.rates[index].rate = rateModel.rate
        } else {
          this.form.rates[index].rate = ''
        }

        this.form.rates[index].code = rateModel.currency
      })

    }
  },
  created() {
    this.handleInputRates()

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/js/views/front/modals/EditRatesModal.vue